import { css } from 'aphrodite';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { Dropdown, DropdownContent, DropdownItem, DropdownTrigger } from '../../../web/components-v2/Dropdown';
import { CalendarDateIcon } from '../../../web/components/svgs/icons/CalendarDateIcon';
import { LogoutIcon } from '../../../web/components/svgs/icons/LogoutIcon';
import { MenuIcon } from '../../../web/components/svgs/icons/MenuIcon';
import { PhoneIcon } from '../../../web/components/svgs/icons/PhoneIcon';
import { QuestionMarkIcon } from '../../../web/components/svgs/icons/QuestionMarkIcon';
import { brandPrimary, white } from '../../styles/colors';
import { TrophyIcon } from '../svgs/icons/TrophyIcon';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
}

export const MobileMenu: React.FC<IProps> = ({ className = '' }) => {
	const history = useHistory();

	return (
		<div className={`${css(styleSheet.userOptionsContainer)} ${className}`}>
			<Dropdown>
				<DropdownTrigger className={css(styleSheet.select)}>
					<MenuIcon className={css(styleSheet.mobileMenu)} fillColor={white} />
				</DropdownTrigger>
				<DropdownContent>
					<DropdownItem onClick={() => history.push('/call-log')} styles={[styleSheet.optionStyles]}>
						<div className={css(styleSheet.optionContent)}>
							<PhoneIcon fill={brandPrimary} className={css(styleSheet.iconSize)} />
							Call Logs
						</div>
					</DropdownItem>
					<DropdownItem
						onClick={() => history.push('/leaderboard?view=leaderboard')}
						styles={[styleSheet.optionStyles]}
					>
						<div className={css(styleSheet.optionContent)}>
							<TrophyIcon fillColor={brandPrimary} className={css(styleSheet.iconSize)} />
							Leaderboard
						</div>
					</DropdownItem>
					<DropdownItem onClick={() => history.push('/leaderboard?view=demos')} styles={[styleSheet.optionStyles]}>
						<div className={css(styleSheet.optionContent)}>
							<CalendarDateIcon fillColor={brandPrimary} className={css(styleSheet.iconSize)} />
							Demos
						</div>
					</DropdownItem>
					<DropdownItem onClick={() => window.open('https://aida.help.levitate.ai')} styles={[styleSheet.optionStyles]}>
						<div className={css(styleSheet.optionContent)}>
							<QuestionMarkIcon fillColor={brandPrimary} className={css(styleSheet.iconSize)} />
							Help
						</div>
					</DropdownItem>
					<DropdownItem onClick={() => history.push('/logout')} styles={[styleSheet.optionStyles]}>
						<div className={css(styleSheet.optionContent)}>
							<LogoutIcon fill={brandPrimary} className={css(styleSheet.iconSize)} />
							Logout
						</div>
					</DropdownItem>
				</DropdownContent>
			</Dropdown>
		</div>
	);
};
